import { Trans } from 'react-i18next';
import { ExpiredVariableDto } from 'services/api/api-client.types';
import styles from './ExpiredVariablesToast.module.scss';
import { TextButton } from 'components/uikit/buttons/TextButton';

type ExpiredVariablesToastProps = {
  expiredVariables: ExpiredVariableDto[];
  triggerExport: () => Promise<void>;
};

export const ExpiredVariablesToast: React.FC<ExpiredVariablesToastProps> = (
  props,
) => {
  const { expiredVariables, triggerExport } = props;

  return (
    <div className={styles.container}>
      <span>
        <Trans
          i18nKey={`Page.DocumentEditor.Export.ExpiredVariableToast.description_${expiredVariables.length === 1 ? 'singular' : 'plural'}`}
          values={{
            variableId: expiredVariables[0].variableId,
            variableName: expiredVariables[0].variableName,
            count: expiredVariables.length,
          }}
          components={{
            bold: <b />,
          }}
        />
      </span>

      <TextButton
        className={styles.updateButton}
        title={'Update and export'}
        onClick={triggerExport}
      />
    </div>
  );
};
